import Vue from "vue";

function add0(m) {
	return m < 10 ? '0' + m : m
}

//时间戳转时间
export const timestampToDate = (ns) => {
	var time = new Date(ns);
	var y = time.getFullYear()
	var m = time.getMonth() + 1
	var d = time.getDate()
	var h = time.getHours()
	var mm = time.getMinutes()
	var s = time.getSeconds()
	// + ' ' + add0(h) + ':' + add0(mm) + ":" + add0(s)
	return y + '-' + add0(m) + '-' + add0(d) 
}
//时间戳转时间
export const timestampToyesterdayDate = () => {
	var time = new Date();
	time.setDate(time.getDate()-1)
	var y = time.getFullYear()
	var m = time.getMonth() + 1
	var d = time.getDate()
	return y + '-' + add0(m) + '-' + add0(d) 
}
/**
 * 获取时间戳
 */
export const getTimestamp = function() {
	const timestamp = new Date().getTime();
	return timestamp;
}
/* js日期 根据时间戳获取以下格式
  几年前
  几个月前
  几小时前 
  几分钟前*/
export const dataDiff = function(hisTime, nowtime, hisTimeS) {
	let now = nowtime ? nowtime : new Date().getTime();
	let diffValue = now - hisTime;
	let result = "";
	let minite = 1000 * 60;
	let hour = minite * 60;
	let day = hour * 24;
	let halfMonth = day * 15;
	let month = day * 30;
	let year = month * 12
	let _year = diffValue / year
	let _month = diffValue / month
	let _day = diffValue / day
	let _hour = diffValue / hour
	let _min = diffValue / minite;
	// if (_year >= 1) result = parseInt(_year) + '年前';
	// else if (_month >= 1) result = parseInt(_month) + '个月前';
	if (_day >= 1) {
		if (_day > 7) {
			result = hisTimeS 
		} else {
			result = parseInt(_day) + '天前'
		}
	} else if (_hour >= 1) result = parseInt(_hour) + '个小时前';
	else if (_min >= 1) result = parseInt(_min) + '分钟前';
	return result
}


export const globalEvt = new Vue();
